import { installPinia } from '@/pinia'
import router from '@/router'
import registerSentry from '@/sentry'
import getEnv from '@/util/env'
import { queryClient } from '@/util/queryClient'
import { VueQueryPlugin } from '@tanstack/vue-query'
import FloatingVue from 'floating-vue'
import type { App } from 'vue'

export const setupAppWithGlobalDependencies = (
  app: App<Element>,
): App<Element> => {
  const dsn = getEnv('VITE_APP_SENTRY_DSN')
  if (dsn) {
    registerSentry(app, dsn)
  }

  // Router
  app.use(router)

  // Data stores
  installPinia(app, [])

  /*
    Server state (caching, dedup, polling) for portalApi calls
   */
  app.use(VueQueryPlugin, { queryClient })

  /*
    Floating ui
   */
  app.use(FloatingVue)
  return app
}
